import styled from 'styled-components';
import { Base, Theme } from 'styled';
import { Props } from './index';

type ArticleTitleProps = Pick<Props, 'textColor'>;

export const Container = styled(Base)`
  display: flex;
  align-items: center;
`;

export const ArticleTitle = styled(Base)<ArticleTitleProps>`
  text-overflow: ellipsis;
  white-space: nowrap;
  ${({ theme }) => theme.typography.variants.primary.xs};
  color: ${({ theme, textColor }) => theme.colors[textColor]};
  font-weight: ${({ theme }) => theme.typography.weight.bold};
  max-width: calc(100vw - 4rem);

  ${Theme.mediaQueries.sm} {
    max-width: unset;
  }
`;
